// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/script-image/script-image.component.scss
// module id = 486
// module chunks = 0